module.exports = __webpack_public_path__ + "static/media/sales.933e0eae.png";